import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CartItem } from 'models/cartItem';
import { CartItems } from 'models/cartItems';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericModalService } from '../../generic-modal';

@Component({
    selector: 'da-hotel',
    templateUrl: './hotel.component.html',
    styleUrls: ['./hotel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotelComponent implements OnInit {
    @Input() event: CartItem;
    @ViewChild('overlay', { static: true }) private _overlay;
    private _modalId: string;
    public courseImage: string;
    public alt: string;

    private _$list: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    public get list$(): Observable<any> {
        return this._$list.asObservable();
    }

    private _$courseImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);

    public get courseImage$(): Observable<{}> {
        return this._$courseImage.asObservable();
    }

    constructor(private _genericModalService: GenericModalService) {}
    ngOnInit() {
        if (this.event && this.event.location && this.event.location.image) {
            if (this.event.location.image.uri) {
                this.courseImage = environment.APIEndpoint + this.event.location.image.uri;
                this._$courseImage.next(this.courseImage);
            }
            if (this.event.location.image && this.event.location.image.fileName) this.alt = this.event.location.image.fileName;
        }
    }

    public openOverlay(city: any): void {
        this._overlayHandler();

        this._$list.next(this.event.location.hotels);
    }

    private _overlayHandler(): void {
        this._modalId = this._genericModalService.create(this._overlay);
        this._genericModalService.open(this._modalId, this._overlay);
    }

    public closeModal() {
        this._genericModalService.close(this._modalId);
    }
}
